import React, { useState, useEffect } from 'react';
import {
  MAX_PRICING_QUOTE_PRICES,
  MIN_QUESTIONS,
  MAX_QUESTIONS,
  AT_LEAST_ONE_LOCATION_TOOLTIP,
} from './utils';
import NumberChooserAndTracker from './NumberChooserAndTracker';

const MAX_QUESTION_COUNT_TOOLTIP =
  "You've reached the max number of question counts you can add";
const QUESTION_COUNT_ALREADY_TOOLTIP = 'Question count already added';

const LABEL = `Choose up to ${MAX_PRICING_QUOTE_PRICES} question lengths (${MIN_QUESTIONS} - ${MAX_QUESTIONS})`;
export default function NumOfQuestionChooser({
  setNumberOfQuestionsToAdd,
  canAddMoreQuestions,
  addQuestionCount,
  isLoading,
  numberOfQuestions,
  setNumberOfQuestions,
  numberOfQuestionsToAdd,
}: {
  setNumberOfQuestionsToAdd: React.Dispatch<React.SetStateAction<number>>;
  canAddMoreQuestions: boolean;
  addQuestionCount: () => void;
  isLoading: boolean;
  numberOfQuestions: number[];
  setNumberOfQuestions: (numberOfQuestions: number[]) => void;
  numberOfQuestionsToAdd: number;
}) {
  const [addQuestionCountTooltip, setAddQuestionCountTooltip] = useState(
    AT_LEAST_ONE_LOCATION_TOOLTIP,
  );
  useEffect(() => {
    if (numberOfQuestions.length === MAX_PRICING_QUOTE_PRICES) {
      setAddQuestionCountTooltip(MAX_QUESTION_COUNT_TOOLTIP);
    } else if (numberOfQuestions.includes(numberOfQuestionsToAdd)) {
      setAddQuestionCountTooltip(QUESTION_COUNT_ALREADY_TOOLTIP);
    } else {
      setAddQuestionCountTooltip(AT_LEAST_ONE_LOCATION_TOOLTIP);
    }
  }, [numberOfQuestions, numberOfQuestionsToAdd]);
  return (
    <NumberChooserAndTracker
      label={LABEL}
      numberType="Number of Questions"
      setNumberToAdd={setNumberOfQuestionsToAdd}
      addNumber={addQuestionCount}
      addNumberTooltip={addQuestionCountTooltip}
      canAddMoreNumbers={canAddMoreQuestions}
      isLoading={isLoading}
      workingNumberList={numberOfQuestions}
      setNumberList={setNumberOfQuestions}
      maxRecommendedNumber={0}
      minNumber={MIN_QUESTIONS}
      maxNumber={MAX_QUESTIONS}
    />
  );
}
